import { DropdownOptions } from '../components/form_v2/types';

export enum Season {
    Winter = 'winter',
    Spring = 'spring',
    Summer = 'summer',
    Fall = 'fall',
}

export interface ISeasonObj {
    dateStart: string;
    dateEnd: string;
}

export interface ISeason {
    [Season.Winter]: ISeasonObj;
    [Season.Spring]: ISeasonObj;
    [Season.Summer]: ISeasonObj;
    [Season.Fall]: ISeasonObj;
}

export interface ILocation {
    lat?: string | undefined | number | google.maps.LatLng | google.maps.LatLngLiteral;
    lng?: string | undefined | number | google.maps.LatLng | google.maps.LatLngLiteral;
}

export interface ITemp {
    minTemp: number;
    maxTemp: number;
    avgTemp: number;
}

export interface ISeasonalTemp {
    [Season.Winter]: ITemp;
    [Season.Spring]: ITemp;
    [Season.Summer]: ITemp;
    [Season.Fall]: ITemp;
}

export interface IWeatherAPIResponse {
    date: string;
    tavg: number;
    tmin: number;
    tmax: number;
    prcp: number;
    snow?: string | null;
    wdir?: string | null;
    wspd: number;
    wpgt?: string | null;
    pres: number;
    tsun?: string | null;
}

export const enum OmekaMedia {
    Image = 'image',
    Video = 'video',
    Attachments = 'application'
}

export const acceptedImage = ['.jpeg', '.jpg', '.tiff', '.raw', '.png'];
export const acceptedVideo = ['.mp4', '.avi'];
export const acceptedAudio = ['.mp3'];
export const acceptedDoc = ['.pdf'];

export interface ILevel3 {
    level1Id: number;
    level1Title: string;
    key: string;
    value: number;
    parent: string;
}

export interface Ilevels {
    key: string, value: number
}

export enum Title_Naming {
    ReserveLocation = 1,
    InsertLocation = 2,
    InsertProfessional = 3,
    UpdateLocation = 4,
    UpdateProfessional = 5
}

export interface ILocationDetails {
    title?: string;
    tags?: string[];
    info?: string;
    tags_gr?: string[];
    info_en?: string;
    amea_access?: boolean;
    overweight_vehicle_access?: boolean;
    restrictions?: string;
    restrictions_en?: string;
    location_category_level_1?: DropdownOptions[];
    location_category_level_2?: DropdownOptions[];
    location_category_level_3?: ILevel3[];
    tk?: string;
    address?: string;
    address_number?: string;
    latitude?: string;
    longitude?: string;
    show_on_map?: string;
    name?: string;
    lastname?: string;
    mobile?: string;
    email?: string;
    website?: string;
    city?: number;
    category?: ILevel3[];
    is_request_responsible?: boolean,
    media?: string[];
    attached_files?: string[];
    thumbnail?: string;
    resume?: string;
    region_id?: number;
    termsAndConditions?: boolean;
    location_id?: number;
    application_id?: number;
    type_of_application?: Title_Naming;
    licensing?: string;
    licensing_en?: string;
    is_applicant_user?: boolean;
    status?: string;
    applicant_role?: string;
    preinserted?: boolean
}

export enum AuthMethod {
    BASIC_AUTH = 'Email/Password',
    EXTERNAL_TAXISNET = 'taxis',
    EXTERNAL_GOOGLE = 'google',
    EXTERNAL_FACEBOOK = 'facebook',
    EXTERNAL_MICROSOFT = 'microsoft'
}

export enum ApiUsability {
    Google_Vision = 1,
    Google_Maps = 2,
    Weather = 3,
    IP = 4,
    Geolocation = 5,
    Distance = 6
}


/** Db ids of title_naming */
export enum ApplicationTitles {
    InternalLocationApplication = 2,
    InternalLocationApplicationModificationRequest = 4,
    InternalProfessionalsApplication = 3,
    InternalProfessionalsApplicationModificationRequest = 5,
}


export enum CookiesValues {
    RLogUserSearches = 'r_log_user_searches',
    RLogLoginLogout = 'r_log_login_logout',
    RLogCountry = 'r_log_country',
    RLogFavorite = 'r_log_favorite',
    RLogRegisters = 'r_log_registers',
    RLogApplications = 'r_log_applications',
    RLogUserInfo = 'r_log_user_info',
}


export enum AppleTitleNamingKeys {

    FilmingRequest = 1,
    LocationRegister = 2,
    ProfessionalRegister = 3,
    EditLocation = 4,
    EditProfessional = 5,
    ContactProfessional = 6,
    ContactLocation = 58,


}